module.exports = __webpack_public_path__ + "img/waiting.4f60744.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/waiting.svg
// module id = ./assets/img/waiting.svg
// module chunks = 2 3 4 5 6 7 8